export const classes = {
  wrapper: 'relative size-full px-6 py-4 place-start',
  imgWrapper:
    'size-24 place-center bg-white dark:bg-[#332e43] rounded-xl shadow-lg',
  img: 'rounded-lg max-w-full max-h-full bg-white dark:bg-[#332e43]',
  name: 'text-base font-medium text-grey-8 dark:text-mauve-1',
  closeIcon:
    'absolute top-0 right-0 text-2xl mr-3 mt-2 text-grey-7 dark:text-mauve-2 hover:text-grey-8 dark:hover:text-mauve-1 transition-colors cursor-pointer',
  title: 'select-none text-inherit mb-2',
  fileName: 'select-none text-inherit font-semibold',
  subtitle: 'select-none font-light text-base text-sm',
  content: 'pl-6 pr-4',
};
